import { jsxs as i, jsx as m } from "react/jsx-runtime";
import { cn as e } from "@tameeni/shared-logic";
import "react";
import "@tameeni/ui";
import "@tameeni/icons";
import { SectionSubtitle as p } from "../typography/section-subtitle.js";
import { SectionTitle as t } from "../typography/section-title.js";
function S({ title: o, subtitle: r, children: c, className: n }) {
  return /* @__PURE__ */ i("section", { className: e("box py-6 lg:py-14", n), children: [
    (o || r) && /* @__PURE__ */ i("div", { className: "box mb-8", children: [
      o && /* @__PURE__ */ m(t, { children: o }),
      r && /* @__PURE__ */ m(p, { children: r })
    ] }),
    c
  ] });
}
export {
  S as HomeSection
};
//# sourceMappingURL=home-section.js.map
